<template>
  <div class="border border-true-gray-700 sm:flex sm:justify-between bg-true-gray-800 relative">
    <!-- <div class="w-full sm:w-2/5">
      <img :src="reviewer.imageSrc" class="w-full h-full object-cover" alt="Reviewer Cover Photo" />
    </div> -->
    <div class="relative pt-48 pb-10 shadow overflow-hidden w-full sm:w-2/5">
      <img class="absolute inset-0 h-full w-full object-cover filter grayscale" :src="reviewer.imageSrc" :alt="`${reviewer.name} Reviewer Cover Photo`" />
      <div class="absolute inset-0 bg-yellow-500 mix-blend-multiply" />
      <div class="absolute inset-0 bg-gradient-to-t from-yellow-400 via-yellow-600 opacity-10" />
    </div>
    <div class="relative px-4 py-4 sm:py-10 sm:px-10 lg:py-10 space-y-2 w-full sm:w-3/5">
      <div class="flex items-center space-x-2">
        <h2 class="text-lg sm:text-2xl font-extrabold text-warm-gray-300">{{ reviewer.name }}</h2>
        <span v-if="reviewer.isNew" class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-yellow-400 bg-opacity-10 text-yellow-400 ring-yellow-400 ring-opacity-30">NEW</span>
      </div>
      <p class="text-sm sm:text-base text-warm-gray-400 mt-3">
        {{ reviewer.description }}
      </p>
      <!-- Buttons will be displayed here -->
      <div class="flex flex-col space-y-2 mt-8">
        <div v-if="reviewer.oldId == 'mtp'">
          <div class="border border-yellow-500 text-yellow-400 text-sm bg-yellow-900 bg-opacity-20 py-2 px-3 rounded-md mt-3 mb-3 sm:mb-6">
            The MTP Reviewer just got a major upgrade. Access it here.
          </div>
          <button @click="openMtpHandoff" type="button" class="w-full text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 text-base font-semibold text-black hover:bg-yellow-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
            Explore the New MTP Reviewer
          </button>
        </div>
        <div v-else-if="reviewer.name == 'CAAP 101'">
          <div class="border border-yellow-500 text-yellow-400 text-sm bg-yellow-900 bg-opacity-20 py-2 px-3 rounded-md mt-3 mb-3 sm:mb-6">
            This is a free reviewer. You can start reviewing immediately.
          </div>
          <button @click="navigateTo(reviewer.path)" class="w-full text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 text-base font-semibold text-black hover:bg-yellow-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
            Start Review
          </button>
        </div>
        <div v-else-if="reviewer.userData && reviewer.userData.subscriptionStatus == 'ACTIVE'">
          <div class="border border-yellow-500 text-yellow-400 text-sm bg-yellow-900 bg-opacity-20 py-2 px-3 rounded-md mt-3 mb-3 sm:mb-6">
            Your reviewer access will expire on <strong>{{ reviewer.userData.expirationDate }}</strong>.
          </div>
          <button @click="navigateTo(reviewer.path)" class="w-full text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 text-base font-semibold text-black hover:bg-yellow-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
            Start Review
          </button>
        </div>
        <div v-else-if="reviewer.userData && reviewer.userData.subscriptionStatus == 'WAITING'">
          <div class="border border-blue-700 text-blue-500 text-sm bg-blue-900 bg-opacity-20 py-2 px-3 rounded-md mt-3 mb-3 sm:mb-6">
            Your payment is being reviewed. It should be approved within 24 hours. If you have any urgent questions or concerns, please contact us at <a href="mailto:support@skilltech.com" class="text-blue-500 hover:text-blue-600">support@skilltech.ph</a>.
          </div>
          <button type="button" disabled class="w-full text-center whitespace-nowrap text-base rounded-md bg-true-gray-700 py-3 text-base font-semibold text-true-gray-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500 cursor-not-allowed pointer-events-none">
            Waiting for Payment Confirmation
          </button>
        </div>
        <div v-else-if="reviewer.userData && reviewer.userData.subscriptionStatus == 'READY'">
          <div class="border border-indigo-400 text-indigo-400 text-sm bg-indigo-800 bg-opacity-20 py-2 px-3 rounded-md mt-3 mb-3 sm:mb-6">
            Your reviewer can now be activated. Please be advised that the {{ reviewer.userData.durationInWords ? reviewer.userData.durationInWords : '' }} duration will only start once you activate your reviewer. You can activate it anytime you are ready.
          </div>
          <button @click="handleActivateModal" class="w-full text-center whitespace-nowrap text-base rounded-md bg-indigo-600 py-3 text-base font-semibold text-white hover:bg-indigo-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
            Activate Reviewer Now
          </button>
        </div>
        <div v-else>
          <div class="border border-red-400 text-red-400 text-sm py-2 px-3 rounded-md bg-red-900 bg-opacity-20 mt-3 mb-3 sm:mb-6">
            No subscription purchased. Click the "Buy A Subscription" button above to see all offers.
          </div>
          <button type="button" disabled class="w-full text-center whitespace-nowrap text-base rounded-md bg-true-gray-700 py-3 text-base font-semibold text-true-gray-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500 cursor-not-allowed pointer-events-none">
            No Subscription
          </button>
        </div>
      </div>


    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { mtpHandoffPath, openMtpApp } from '@/utils/mtpAppLink';

const router = useRouter();
const emit = defineEmits(['handleActivateModal']);
const props = defineProps({
  reviewer: {
    type: Object,
    required: true,
  },
});

const navigateTo = (path) => {
  console.log('Navigating to', path);
  router.push(path);
}

const openMtpHandoff = () => {
  const status = props.reviewer.userData && props.reviewer.userData.subscriptionStatus;
  openMtpApp('reviewers_card', mtpHandoffPath(status));
};

const handleActivateModal = () => {
  emit('handleActivateModal', props.reviewer);
}
</script>